import React, { useState } from "react";
import axios from "axios";

const ContactModal = ({ isOpen, closeModal }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    city: "",
  });

  const [errors, setErrors] = useState({});

  // Handle Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Validation Function
  const validate = () => {
    let newErrors = {};

    // Name (letters only)
    if (!/^[A-Za-z ]{2,}$/.test(formData.name.trim())) {
      newErrors.name = "Enter a valid name (letters only)";
    }

    // Indian phone number (10 digit, starts 6-9)
    if (!/^[6-9][0-9]{9}$/.test(formData.phone.trim())) {
      newErrors.phone = "Enter a valid 10-digit Indian mobile number";
    }

    // City required
    if (!formData.city) {
      newErrors.city = "Please select your city";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const res = await axios.post("/contact.php", formData);

      if (res.data.success) {
        alert("Form submitted successfully!");

        setFormData({
          name: "",
          phone: "",
          city: "",
        });

        setErrors({});
        closeModal();
      } else {
        alert(res.data.message || "Submission failed");
      }
    } catch (error) {
      alert("Failed to submit form. Please try again!");
      console.log("Form Submit Error:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="contact-modal-overlay" onClick={closeModal}>
      <div
        className="contact-modal-box"
        onClick={(e) => e.stopPropagation()}
      >

{/* LEFT SIDE */}
    <div className="contact-left">
      <h2>
        Speak with Architects 
        & Engineers — Not 
        Middlemen
      </h2>

      <div className="contact-points">
        <div className="point">
          <span className="check-icon">✓</span>
          <div>
            <h4>24 x 7 Live Site Monitoring</h4>
            <p>
              Now sit at home and track your construction progress anytime
            </p>
          </div>
        </div>

        <div className="point">
          <span className="check-icon">✓</span>
          <div>
            <h4>Design + Approvals + Build</h4>
            <p>All done in-house — no third parties</p>
          </div>
        </div>

        <div className="point">
          <span className="check-icon">✓</span>
          <div>
            <h4>Smart Pricing : Starts at ₹1270/Sq.Ft</h4>
            <p>
              Includes Architecture Consultancy, Approvals & Construction.
              Honest value. No hidden commissions.
            </p>
          </div>
        </div>
      </div>
    </div>

        {/* RIGHT SIDE  */}

        <div className="contact-right">
          <button className="modal-close" onClick={closeModal}>
            ✕
          </button>

          <h3>Contact Information</h3>
          <p className="form-subtitle">
            One step closer to your perfect home
          </p>

          <form onSubmit={handleSubmit}>
            {/* NAME */}
            <label>Full Name *</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[A-Za-z ]*$/.test(value)) {
                  handleChange(e);
                }
              }}
              className={errors.name ? "error" : ""}
            />
            {errors.name && <p className="form-error">{errors.name}</p>}

            {/* PHONE */}
            <label>Phone Number *</label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[0-9]*$/.test(value) && value.length <= 10) {
                  handleChange(e);
                }
              }}
              className={errors.phone ? "error" : ""}
            />
            {errors.phone && <p className="form-error">{errors.phone}</p>}

            {/* CITY */}
            <label>Select City *</label>
           <select
  name="city"
  value={formData.city}
  onChange={handleChange}
  style={{ color: formData.city === "" ? "#444" : "#222" }}
   className="custom-select"
>
  <option value="" disabled hidden>
    Select your city
  </option>
  <option value="Pune">Pune</option>
  <option value="Nashik">Nashik</option>
  <option value="Latur">Latur</option>
  <option value="Sambhajinagar">Sambhajinagar</option>
</select>
            {errors.city && <p className="form-error">{errors.city}</p>}

            <button type="submit" className="submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;